import { useEffect, useState } from 'react';
import appManager from './AppManager';

export default () => {
  const [config, setAppConfig] = useState(() => {
    return null;
  });

  useEffect(() => {
    // 只初始化并设置一次，如果要用最新配置需要刷新页面
    appManager.getMicroAppConfig().then((appConfig: any) => {
      setAppConfig(appConfig);
    });
  }, []);

  return { appConfig: config as any };
};
